
import { Route, createBrowserRouter, createRoutesFromElements } from "react-router-dom";

import Emergency from "../components/pages/Emergency";
import Error from "../components/pages/Error";
import FAQ from "../components/pages/FAQ";
import Home from "../components/pages/Home";
import Register from "../components/pages/Register";
import { MainLayout } from "../components/layouts/MainLayout";
import Submitted from "../components/pages/Submitted";
import Pending from "../components/pages/Pending";
import RequestSubmitted from "../components/pages/RequestSubmitted";
import MaintenancePage from "../components/pages/Maintenance";

export const AppRoutes = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<MainLayout />} path="/">
      <Route index element={<Home />} path="/" />
      <Route element={<Register />} path="/register" />
      <Route element={<Emergency />} path="/emergency" />
      <Route element={<FAQ />} path="/faq" />
      <Route element={<Error />} path="/error" />
      <Route element={<Submitted />} path="/submitted" />
      <Route element={<RequestSubmitted />} path="/request_submitted" />
      <Route element={<Pending />} path="/pending" />
      <Route element={<Home />} path="*" />
    </Route>,
  ),
);

export const MaintenanceRoute = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<MainLayout />} path="/">
      <Route index element={<MaintenancePage />} path="/" />
      <Route element={<MaintenancePage />} path="*" />
    </Route>,
  ),
);

export const ErrorRoute = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<MainLayout />} path="/">
      <Route index element={<Error />} path="/" />
      <Route element={<Error />} path="*" />
    </Route>,
  ),
);